<span
  [class]="normalizedGender | className"
  [class.child]="isChild"
  [class.warning]="hasWarning"
></span>
